<div class="main-div apearAnimation" style="background-color: #ebebeb;">
    <mat-card style="padding:60px;">
      <mat-card-title style="text-align: center;"> <img style="width: 220px;" src="../../assets/images/livasLogo.png" alt=""> </mat-card-title>
      <mat-card-content style="min-width: 320px;">

      

        <mat-form-field  style="width: 100%;" appearance="outline">
          <input type="text" matInput placeholder="Email" [(ngModel)]="email"  style="width: 100%;" />
        </mat-form-field>
        <br />
        <mat-form-field  style="width: 100%;" appearance="outline">
          <input
              [type]="hide ? 'password' : 'text'"
            [(ngModel)]="password"
            matInput
            placeholder="Contraseña"
             style="width: 100%;"
             
          />
          <button
          type="button"
          mat-icon-button
          matSuffix
          (click)="hide = !hide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="hide"
        >
          <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
        </button>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions *ngIf="!iswhaiting">
        <div class="button-flex-container">
          <button mat-raised-button color="primary" (click)="login()">
            Ingresar
          </button>
        </div>
      </mat-card-actions>

      <div class="contenedorSpinner" *ngIf="iswhaiting">
        <div class="loading-indicator">
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      </div>

      <mat-card-footer>
        <a mat-button (click)="recordarPassword()">Olvido la contraseña</a>
      </mat-card-footer>
    </mat-card>

</div>
